/* Liczniki wspólnych wystąpień, bez prognoz. Duże drzewa mają jawny budżet. */
(function (root, factory) {
    'use strict';
    var api = factory();
    if (typeof module === 'object' && module.exports) module.exports = api;
    root.PewniakiGrupy = api;
})(typeof globalThis !== 'undefined' ? globalThis : this, function () {
    'use strict';
    function compare(a, b) {
        if (a.count !== b.count) return b.count - a.count;
        for (var i = 0; i < a.numbers.length; i++) if (a.numbers[i] !== b.numbers[i]) return a.numbers[i] - b.numbers[i];
        return 0;
    }
    function intersection(a, b) {
        var out = [], i = 0, j = 0;
        while (i < a.length && j < b.length) {
            if (a[i] === b[j]) { out.push(a[i]); i++; j++; }
            else if (a[i] < b[j]) i++; else j++;
        }
        return out;
    }
    function prepare(draws, pool, pick) {
        if (!Array.isArray(draws) || !Number.isInteger(pool) || pool < 2 || pool > 80) throw Error('format');
        var vertical = Array.from({ length: pool + 1 }, function () { return []; });
        draws.forEach(function (d, i) {
            var ns = d && d.numbers;
            if (!Array.isArray(ns) || ns.length !== pick || new Set(ns).size !== pick || ns.some(function (n) { return !Number.isInteger(n) || n < 1 || n > pool; })) throw Error('draw');
            ns.forEach(function (n) { vertical[n].push(i); });
        });
        return vertical;
    }
    function distribution(draws, numbers) {
        var bins = Array(numbers.length + 1).fill(0);
        draws.forEach(function (d) { bins[numbers.filter(function (n) { return d.numbers.indexOf(n) >= 0; }).length]++; });
        return bins;
    }
    function* search(draws, size, pool, pick, options) {
        options = options || {};
        if (!Number.isInteger(size) || size < 1 || size > Math.min(pick, 10)) throw Error('size');
        var vertical = prepare(draws, pool, pick), top = [], found = new Set(), visited = 0;
        var limit = Math.max(1, Math.min(20, options.limit || 20)), budget = Math.max(1, options.budget || 250000), complete = true;
        function add(ns, support) {
            var key = ns.join('-'); if (found.has(key)) return;
            found.add(key); top.push({ numbers: ns, count: support.length }); top.sort(compare);
            if (top.length > limit) { found.delete(top.pop().numbers.join('-')); }
        }
        function worse(prefix, support, candidates) {
            if (top.length < limit) return false;
            var last = top[top.length - 1];
            if (support.length < last.count) return true;
            if (support.length > last.count) return false;
            var smallest = prefix.concat(candidates.slice(0, size - prefix.length).map(function (c) { return c.number; }));
            return smallest.length < size || compare({ numbers: smallest, count: support.length }, last) >= 0;
        }
        function* walk(prefix, candidates) {
            for (var i = 0; i <= candidates.length - (size - prefix.length); i++) {
                if (++visited > budget) { complete = false; return; }
                if (visited % 512 === 0) yield visited;
                var c = candidates[i], ns = prefix.concat(c.number), remaining = candidates.slice(i + 1);
                if (!c.support.length || worse(ns, c.support, remaining)) continue;
                if (ns.length === size) { add(ns, c.support); continue; }
                var next = [];
                for (var j = 0; j < remaining.length; j++) {
                    if (++visited > budget) { complete = false; return; }
                    if (visited % 512 === 0) yield visited;
                    var common = intersection(c.support, remaining[j].support);
                    if (common.length) next.push({ number: remaining[j].number, support: common });
                }
                if (next.length >= size - ns.length) yield* walk(ns, next);
                if (!complete) return;
            }
        }
        var candidates = []; for (var n = 1; n <= pool; n++) if (vertical[n].length) candidates.push({ number: n, support: vertical[n] });
        yield* walk([], candidates);
        return { rows: top.map(function (r) { return { numbers: r.numbers, count: r.count, distribution: distribution(draws, r.numbers) }; }), n: draws.length, size: size, complete: complete, visited: Math.min(visited, budget) };
    }
    async function rank(draws, size, pool, pick, options) {
        options = options || {}; var it = search(draws, size, pool, pick, options), step;
        do {
            if (options.cancelled && options.cancelled()) throw Error('cancel');
            step = it.next();
            if (!step.done) await new Promise(function (resolve) { setTimeout(resolve, 0); });
        } while (!step.done);
        return step.value;
    }
    return { search: search, rank: rank, distribution: distribution };
});
